/**
 * Turn any API error into a safe, human string.
 *
 * FastAPI can return a structured `detail` (an ARRAY for 422 validation errors,
 * an OBJECT for our 409 "choice required" response). Rendering that object
 * directly throws React error #31 ("Objects are not valid as a React child")
 * and blanks the whole page, so every catch must pass its error through here
 * before putting it in state.
 */
export function errText(err: unknown, fallback = 'Something went wrong.'): string {
  const detail = (err as any)?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d: any) => (typeof d === 'string' ? d : d?.msg || d?.message))
      .filter(Boolean);
    if (msgs.length) return msgs.join('; ');
  }
  if (detail && typeof detail === 'object') {
    // Our own structured errors carry a human `message`.
    if (typeof detail.message === 'string' && detail.message.trim()) return detail.message;
    try { return JSON.stringify(detail); } catch { /* fall through */ }
  }
  const message = (err as any)?.message;
  if (typeof message === 'string' && message.trim()) return message;
  return fallback;
}
